import { render, staticRenderFns } from "./ALS.vue?vue&type=template&id=45bb7eed&scoped=true"
var script = {}
import style0 from "./ALS.vue?vue&type=style&index=0&id=45bb7eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb7eed",
  null
  
)

export default component.exports